exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".publication{border-bottom:1px solid #d8d8d8;padding-bottom:15px;margin-bottom:15px}.publication.borderBottom{border-bottom:none}.publication .title{font-size:16px;color:#c37eeb;font-family:\"SF-Pro-Display-Medium\";font-weight:500;margin-bottom:5px;width:max-content;cursor:pointer}.publication .title.edit{font-size:18px;color:#303b43}.publication .details{font-size:13px;color:#898989;font-family:\"SF-Pro-Display-Regular\";font-weight:normal;margin-bottom:15px}.publication .details.edit{color:#8a8a8a;text-align:start}.publication .text{font-size:15px;color:#555555;font-family:\"SF-Pro-Display-Regular\";text-overflow:ellipsis;overflow:hidden;display:-webkit-box;max-width:345px;-webkit-line-clamp:3;-webkit-box-orient:vertical}.publication .text.edit{text-align:start;color:#383838}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/Publication/style.scss
// module id = 1516
// module chunks = 0